








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class extends Vue{
    @Prop({default:'暂无内容'})
    text!:string

    @Prop({default:25})
    height!:number | string

    get compHeight(){
        let res = ''
        if(typeof(this.height) == 'number'){
            res =  this.height + 'rem'
        }
        else res = this.height
        return res
    }
}
